// E2 / ADMIN Waive ceremony.

import { useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { Button, Textarea, FormField } from "@/design-system/components/ui";

interface WaiveModalProps {
  open: boolean;
  onClose: () => void;
  itemCode: string;
  onConfirm: (rationale: string) => void | Promise<void>;
  pending?: boolean;
}

export function WaiveModal({
  open,
  onClose,
  itemCode,
  onConfirm,
  pending = false,
}: WaiveModalProps) {
  const [rationale, setRationale] = useState("");
  const isValid = rationale.trim().length > 0;

  return (
    <Modal
      open={open}
      onClose={onClose}
      dismissOnBackdropClick={false}
      title={`Waive ${itemCode}`}
      description="Waivers are exceptional and recorded loudly in the audit log."
      size="md"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={pending}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => void onConfirm(rationale)}
            disabled={!isValid || pending}
          >
            {pending ? "Waiving…" : "Waive item"}
          </Button>
        </>
      }
    >
      <FormField label="Waiver rationale" required>
        <Textarea
          rows={5}
          value={rationale}
          onChange={(e) => setRationale(e.target.value)}
          placeholder="Why is this item being waived for this deal?"
        />
      </FormField>
    </Modal>
  );
}
